import { useEffect, useState } from 'react';

/**
 * Chats the person marked unread by hand in this tab: an open chat does not mark itself read again until it
 * is opened anew (otherwise "mark unread" on the open chat would undo itself at once).
 */
const keptUnread = new Set<string>();

export function keepUnread(conversationId: string, on: boolean) {
  if (on) keptUnread.add(conversationId);
  else keptUnread.delete(conversationId);
}

export const isKeptUnread = (conversationId: string) => keptUnread.has(conversationId);

/** True while the tab is visible (re-renders on change). */
export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(() => typeof document === 'undefined' || !document.hidden);
  useEffect(() => {
    const on = () => setVisible(!document.hidden);
    document.addEventListener('visibilitychange', on);
    return () => document.removeEventListener('visibilitychange', on);
  }, []);
  return visible;
}
